<div>
  {{ "SHARED.NO_EDIT_ROLE.MESSAGE" | translate }}
</div>
